import { combineReducers } from '@reduxjs/toolkit';
import branding from '../../shared/reducers/branding';
import client from '../../shared/reducers/client';
import contacts from '../../shared/reducers/contacts';
import sms from '../../shared/reducers/sms';
import timeIntervals from '../../shared/reducers/timeIntervals';
import user from '../../shared/reducers/user';
import app from './app';
import audio from './audio';
import callHistory from './callHistory';
import calls from './calls';
import extension from './extension';
import vcrm from './vcrm';

const appReducer = combineReducers({
  app,
  audio,
  branding,
  callHistory,
  calls,
  client,
  contacts,
  timeIntervals,
  extension,
  sms,
  user,
  vcrm,
});

export default appReducer;
